import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { I360ValidationModule } from 'app/utils/validator/validation.module';
import { TextInputComponent } from './text-input.component';


@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        I360ValidationModule,
    ],
    declarations: [
        TextInputComponent,
    ],
    exports: [
        TextInputComponent,
        MatInputModule,
    ],
})
export class TextInputModule {}
